import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

type EstudiantesFilters = {
  msisdn?: string;
  iccid?: string;
  nombre?: string;
  institution_id?: number;
};

export async function getAllEstudiantes(filters: EstudiantesFilters) {
  let search = '';

  if (filters) {
    const query: Record<string, string | number> = {};

    if (filters.msisdn && filters.msisdn.trim() !== '') {
      query.msisdn = filters.msisdn;
    }
    if (filters.iccid && filters.iccid.trim() !== '') {
      query.iccid = filters.iccid;
    }
    if (filters.nombre && filters.nombre.trim() !== '') {
      query.name = filters.nombre;
    }
    if (filters.institution_id && filters.institution_id > 0) {
      query.institution_id = filters.institution_id;
    }

    const params = new URLSearchParams(query as Record<string, string>);
    search = `?${params.toString()}`;
  }

  const response = await axios.get(`${API_URL}catalogos/customer${search}`);
  const data = response.data.doc.data;
  return data;
}

export async function sendPeriodic(id: number, active: boolean) {
  const data = { customer_id: id, active };

  const response = await axios.put(
    `${API_URL}catalogos/customer/periodic-recharges/toggle`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return response;
}
